import { CssBaseline,  } from "@mui/material"
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles"
import { default as BiotechDays } from "./BiotechDays/Form"
import { default as Documentation } from "./Documentation/Form"
import { default as JourneesPortesOuvertes } from "./JourneesPortesOuvertes/Form"
import { default as TimeTravel } from "./TimeTravel/Form"
import { default as Newsletter} from "./Newsletter/Form"
import theme from "./Theme/index"
import themeNewsletter from "./Theme/newsletter"
import { FormContextProvider } from "hooks/useForm"
import Forms from "../Forms"

const DocumentationSupbiotech = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <Documentation />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

const BiotechDaysSupbiotech = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <BiotechDays />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

const JourneesPortesOuvertesSupbiotech = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <JourneesPortesOuvertes />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

const TimeTravelSupbiotech = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <TimeTravel />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

const NewsletterSupbiotech = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={themeNewsletter}>
        <Forms>
          <CssBaseline />
          <Newsletter />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

export { BiotechDaysSupbiotech, DocumentationSupbiotech, JourneesPortesOuvertesSupbiotech, TimeTravelSupbiotech, NewsletterSupbiotech }
